import * as React from 'react'
import type { SVGProps } from 'react'
import { type Ref, forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHouse7 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 25'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='house_svg__a'
      width={23}
      height={19}
      x={0}
      y={3}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='M11.485 3.642a1 1 0 0 1 1.03 0l10 6a1 1 0 0 1-1.03 1.715L20 10.466V18.5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-8.034l-1.485.891-.091.048A1 1 0 0 1 1.4 9.7l.085-.057zM6 9.266V18.5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.266l-6-3.6z'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#house_svg__a)'>
      <path fill={props.color} d='M0 .5h24v24H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgHouse7)
export default ForwardRef
